import { css } from "@emotion/core";
import styled from "@emotion/styled";
import { NectarTheme } from "@nectarTypes";
import Skeleton from "react-loading-skeleton";

export const CustomSkeleton = styled(Skeleton)<{ marginBottom: boolean } & NectarTheme>`
  ${({ theme, marginBottom }) => css`
    ${theme.breakpoints.xs} {
      margin-bottom: ${marginBottom ? theme.spacings.sm : 0};
      width: 100%;
    }

    ${theme.breakpoints.sm} {
      max-width: 440px;
    }
  `}
`;

export const SkeletonContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: ${theme.spacings.md};
  `}
`;

export const DocumentsSkeletonContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: grid;
    row-gap: ${theme.spacings.md};
    grid-template-areas:
      "skeletonData"
      "skeletonBody"
      "skeletonButton"
      "divider";

    ${theme.breakpoints.sm} {
      grid-template-columns: 1fr 250px;
      column-gap: ${theme.spacings.sm};
      grid-template-areas:
        "skeletonBody skeletonButton"
        "divider divider";

      #skeleton-data {
        display: none;
      }
    }

    & span {
      flex: 1;
      display: grid;
    }
  `}
`;

export const DocumentsSkeletonBody = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    row-gap: ${theme.spacings.lg};
    column-gap: ${theme.spacings.xs};
    grid-area: skeletonBody;

    ${theme.breakpoints.sm} {
      .skeleton {
        width: 50%;
      }

      .skeleton-title {
        width: 80%;
      }
    }
  `}
`;

export const HistoricalSkeletonContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: grid;
    row-gap: ${theme.spacings.md};
    grid-template-areas:
      "skeletonData"
      "skeletonBody"
      "divider";

    ${theme.breakpoints.sm} {
      grid-template-columns: 200px 1fr;
      column-gap: ${theme.spacings.sm};
      grid-template-areas:
        "skeletonData skeletonBody"
        ". skeletonBody"
        "divider divider";
    }

    .skeletonBody {
      grid-area: skeletonBody;
      display: flex;
      row-gap: ${theme.spacings.xs};
      flex-direction: column;
      margin-top: ${theme.spacings.xxs};

      & span {
        flex: 1;
        display: grid;
      }

      ${theme.breakpoints.sm} {
        width: 70%;
      }
    }

    .skeletonData {
      grid-area: skeletonData;
      width: 60%;

      ${theme.breakpoints.sm} {
        width: 100%;
      }
    }
  `}
`;
